import axios from "axios";
import { createI18n } from "vue-i18n";

async function fetchTranslations(locale) {
    const response = await axios.get(`/api/translations/${locale}`);
    return response.data.data;
}

async function fetchAvailableTranslations() {
    const response = await axios.get(`/api/translations`);
    return response.data.data;
}

export async function createI18nInstance(locale) {
    const messages = await fetchTranslations(locale);

    const i18n = createI18n({
        fallbackLocale: "en",
        legacy: false, // you must set `false`, to use Composition API
        locale: locale,
        messages: {
            [locale]: messages,
        },
    });

    return i18n;
}

export async function setLocale(i18n, newLocale) {
    // Check if the locale is already loaded in messages
    const currentMessages = i18n.global.getLocaleMessage(newLocale);

    if (currentMessages && Object.keys(currentMessages).length > 0) {
        i18n.global.locale.value = newLocale;
        return;
    }

    const availableLocales = await fetchAvailableTranslations();

    if (availableLocales.includes(newLocale)) {
        const messages = await fetchTranslations(newLocale);
        i18n.global.setLocaleMessage(newLocale, messages);
        i18n.global.locale.value = newLocale;
    }
}
